<!-- eslint-disable -->
<template lang="pug">
    .row.user-preview
        .col-xs-10.user-preview__column.user-preview__column_hide-name
            .user-preview__item
                router-link.user-preview__link.user-preview__link_large(
                    v-if="canLinkToUser(profile)"
                    :to="{name: 'user:profile', params: {id: profile.id, type: profile.type}}"
                )
                    img.user-preview__avatar(:src="profile.avatar")
                    span.preview__text.preview__text_large {{ profile.firstName }} {{ profile.lastName }}
                .user-preview__link_large(v-else="")
                    img.user-preview__avatar(:src="profile.avatar")
                    span.preview__text.preview__text_large {{ profile.firstName }} {{ profile.lastName }}
        .col-xs-2.col-sm-1.last-sm.end-xs.user-preview__column(
            :class="{'is-disabled': !canLinkToUser(profile)}"
        )
            dropdown(:icon="false" :is-last="isLast" without-move)
                template(slot="link")
                    svg-icon.user-preview__icon.user-preview__icon_blue(name="select", :size="selectorSize")
                ul.dropdown__links
                    li.dropdown__link
                        router-link.user-preview__link(:to="{name: 'user:profile', params: {id: profile.id, type: profile.type}}")
                            | {{ $i18n.t('list.list_common_actionsOpen') }}
                    template(v-if="profile.id === user.id || !profile.isSuperadmin")
                        li.dropdown__link(
                            v-if="(user.isSuperadmin\
                            || user.isManagerOrSupport\
                            || profile.id === user.id\
                            || (user.type === 'admin'\
                                    && user.schoolsIds.includes(profile.school.id)))\
                                    && profile.status === 'active'"
                            :class="{'is-disabled': areSchoolsBlocked || !areActionsAllowed(profile)}"
                        )
                            router-link.user-preview__link(:to="{name: 'user:edit', params: {id: profile.id, type: profile.type}}")
                                | {{ $i18n.t('list.list_common_actionsEdit') }}
                        li.dropdown__link(
                            v-if="(user.isSuperadmin\
                                || user.isManagerOrSupport\
                                || user.type === 'teacher')\
                                && profile.status === 'active'\
                                && isUserInActiveGrades"
                            :class="{'is-disabled': areSchoolsBlocked || !areActionsAllowed(profile)}")
                            a(
                                href="javascript://"
                                @click="authentication(profile.id)"
                            )
                                | {{ $i18n.t('list.list_common_actionsAuth') }}
                        li.dropdown__link(v-if="isShowLink || user.type === 'admin'")
                            a(
                                href="javascript://"
                                @click="changeStatus"
                                v-if="profile.status === 'active'"
                            )
                                | {{ $i18n.t('list.list_common_actionsArchive') }}
                            a(
                                href="javascript://"
                                @click="checkRestorePrice"
                                v-else
                            )
                                | {{ $i18n.t('list.list_common_actionsRestore') }}
                        li.dropdown__link(v-if="areMilesAllowed")
                            a(
                                href="javascript://"
                                @click="showMilesModal = true"
                            )
                                | {{ $i18n.t('list.list_teacherPreview_actionsAddMiles') }}
                        li.dropdown__link(v-if="areDetectivePointsAllowed")
                            a(
                                href="javascript://"
                                @click="showDetectiveModal = true"
                            )
                                | {{ $i18n.t('list.list_teacherPreview_actionsAddDetectivePoints') }}
                        li.dropdown__link(v-if="arePointsAllowed && profile.pointsAccesses.length === 1")
                            a(
                                href="javascript://"
                                @click="showPointsModal = true"
                            )
                                | {{ $i18n.t('list.list_teacherPreview_actionsAddPoints') }}

                        li.dropdown__link(v-if="isShowLink")
                            a(
                                href="javascript://"
                                @click="displayConfirmDeleteModal = true"
                            )
                                | {{ $i18n.t('list.list_common_actionsDelete') }}
        .col-xs-12.col-sm-11.user-preview__column
            .user-preview__name.hidden-xs
                router-link.user-preview__link.user-preview__link_large(
                    v-if="canLinkToUser(profile)"
                    :to="{name: 'user:profile', params: {id: profile.id, type: profile.type}}"
                )
                    img.user-preview__avatar(:src="profile.avatar")
                    span.preview__text.preview__text_large {{ profile.firstName }} {{ profile.lastName }}
                .user-preview__link_large(v-else="")
                    img.user-preview__avatar(:src="profile.avatar")
                    span.preview__text.preview__text_large {{ profile.firstName }} {{ profile.lastName }}
            .row.user-preview__info
                .col-md-6.info__column
                    .user-preview__items
                        .user-preview__item
                            template(v-if="profile.status === 'active'")
                                svg-icon.user-preview__icon(name="check")
                                .preview__text {{ $i18n.t('common.common_status_active') }}
                            template(v-else)
                                svg-icon.user-preview__icon(name="cancel")
                                .preview__text {{ $i18n.t('common.common_status_archived') }}
                    .user-preview__items.user-preview__items_limited
                        .user-preview__item(:title="this.$i18n.t('list.list_studentPreview_progress')")
                            svg-icon.user-preview__icon(name="goal", size="base")
                            .preview__text {{ averageProgress }}
                        .user-preview__item(
                            v-if="$pointsSystem && access !== 'mathMagic' && profile.pointsAccesses.length === 1"
                            :title="$i18n.t('common.common_points_' + access)"
                            v-for="access in profile.pointsAccesses"
                        )
                            a.user-preview__link(
                                v-if="arePointsAllowed"
                                href="javascript://"
                                @click="showPointsModal = true"
                            )
                                svg-icon.user-preview__icon(name="coin", size="base")
                                .preview__text
                                    | {{ (access === 'mentalArithmetic') ? profile.points - profile.fastReadingPoints : profile.fastReadingPoints }}
                            template(v-else="")
                                svg-icon.user-preview__icon(name="coin", size="base")
                                .preview__text
                                    | {{ (access === 'mentalArithmetic') ? profile.points - profile.fastReadingPoints : profile.fastReadingPoints }}
                        .user-preview__item(
                            v-if="$isDetectiveAvailable && courseAllowDetective"
                            :title="$i18n.t('dashboard.dashboard_sidebar_detectivePoints')"
                        )
                            a.user-preview__link(
                                v-if="areDetectivePointsAllowed"
                                href="javascript://"
                                @click="showDetectiveModal = true"
                            )
                                svg-icon.user-preview__icon(name="explore", size="base")
                                .preview__text
                                    | {{ profile.detectivePoints }}
                            template(v-else="")
                                svg-icon.user-preview__icon(name="explore", size="base")
                                .preview__text
                                    | {{ profile.detectivePoints }}
                        template(v-if="$isMapAvailable && courseAllowMap")
                            .user-preview__item(
                                :title="this.$i18n.t('list.list_studentPreview_miles')"
                            )
                                a.user-preview__link(
                                    v-if="areMilesAllowed"
                                    href="javascript://"
                                    @click="showMilesModal = true"
                                )
                                    svg-icon.user-preview__icon(name="plane", size="base")
                                    .preview__text
                                        | {{ profile.miles }}
                                template(v-else="")
                                    svg-icon.user-preview__icon(name="plane", size="base")
                                    .preview__text
                                        | {{ profile.miles }}
                            .user-preview__item(:title="this.$i18n.t('list.list_studentPreview_city')")
                                svg-icon.user-preview__icon(name="pin", size="base")
                                .preview__text {{ $i18n.t('mapModal.names')[profile.mapLocation.name] }}
                .col-md-6.info__column
                    .user-preview__items.user-preview__items_columned
                        .user-preview__item(
                            v-if="profile.schools.length"
                            v-for="school in profile.schools"
                        )
                            router-link.user-preview__link(v-if="school" :to="{name: 'school:profile', params: {id: school.id}}")
                                svg-icon.user-preview__icon(name="university", size="base")
                                .preview__text {{ school.name }}
                        .user-preview__item(v-else)
                            svg-icon.user-preview__icon(name="university", size="base")
                            .preview__text {{ $i18n.t('list.list_common_noSchool') }}
                        .user-preview__item(
                            v-if="profile.grades && profile.grades.length"
                            v-for="grade in profile.grades"
                        )
                            router-link.user-preview__link(:to="{name: 'grade:profile', params: {id: grade.id}}")
                                svg-icon.user-preview__icon(name="list-inverse", size="base")
                                .preview__text {{ grade.name }}
                        .user-preview__item(v-else)
                            svg-icon.user-preview__icon(name="list-inverse", size="base")
                            .preview__text {{ $i18n.t('list.list_common_noGrade') }}
        confirm-delete-modal(
            v-if="displayConfirmDeleteModal"
            @close="displayConfirmDeleteModal = false"
            @delete="$emit('delete', profile.id)"
        )
            | {{ " " + $i18n.t('list.list_teacherPreview_thisStudent') }}
        points-modal(
            v-if="showPointsModal"
            :user="profile"
            @close="showPointsModal = false"
            @points="user.type !== 'teacher' && (profile.points = +profile.points + arguments[0])"
        )
            | {{ $i18n.t('list.list_user_deleteAdminModal') }}

        miles-modal(
            v-if="showMilesModal"
            :user="profile"
            @close="showMilesModal = false"
            @miles="user.type !== 'teacher' && (profile.miles += arguments[0])"
        )

        detective-points-modal(
            v-if="showDetectiveModal"
            :user="profile"
            @close="showDetectiveModal = false"
            @detectivePoints="user.type !== 'teacher' && (profile.detectivePoints += arguments[0])"
        )

        cs-modal(v-if="priceModal.show" is-blur @close="closePriceModal")
            .price-modal-text(
                v-html="$i18n.t('user.user_form_withdrawal_of_money', { payment: '<b>' + priceModal.price + ' ' + $i18n.tc('olympiads.olympiads_olympiadForm_rubles', priceModal.price) + '</b>' })"
            )
            .price-modal-buttons
                cs-button(color="orange" @click="closePriceModal")
                    | {{ $i18n.t('user.user_form_cancel') }}
                cs-button(@click="changeStatus")
                    | {{ $i18n.t('user.user_form_confirm') }}
</template>

<script>
    /*eslint-disable*/
    import Dropdown from '../../../elements/Dropdown.vue';
    import UserApi from '../../../api/user/user';
    import {mapState} from 'vuex';
    const ConfirmDeleteModal = () => import('../../../modals/ConfirmDeleteModal.vue');
    const PointsModal = () => import('../../../modals/PointsModal.vue');
    const MilesModal = () => import('../../../modals/MilesModal.vue');
    const DetectivePointsModal = () => import('../../../modals/DetectivePointsModal.vue');
    import authentication from '../../../utils/user/authentication'
    import usersListMixin from "../../../utils/user/usersListMixin"
    import courseAccesses from '../../../utils/user/courseAccesses'
    import BillingBlockMixin from '../../../utils/user/BillingBlockMixin';
    import RestoreUserMixin from '../../../utils/user/RestoreUserMixin';

    export default {
        props: {
            profile: Object,
            isLast: Boolean
        },
        data() {
            return {
                displayConfirmDeleteModal: false,
                showPointsModal: false,
                showMilesModal: false,
                showDetectiveModal: false,
                priceModal: {
                    show: false,
                    price: 0,
                },
            };
        },
        mixins: [authentication, usersListMixin, courseAccesses, BillingBlockMixin, RestoreUserMixin],
        components: {
            Dropdown,
            ConfirmDeleteModal,
            PointsModal,
            MilesModal,
            DetectivePointsModal,
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
            }),
            averageProgress() {
                if (this.profile) {
                    let progress = this.profile.averageProgress;
                    return progress && progress.average ? Math.round(progress.average) + '%': '—';
                }
            },
            arePointsAllowed () {
                return this.$pointsSystem && (this.$scoring ?
                        this.user.type !== 'student' && this.profile.status === 'active'
                        : this.user.isSuperadmin || this.user.isManagerOrSupport);
            },
            areMilesAllowed () {
                return (this.$isMapAvailable && this.courseAllowMap) && (this.$scoring ?
                  this.user.type !== 'student' && this.profile.status === 'active'
                  : this.user.isSuperadmin || this.user.isManagerOrSupport);
            },
            areDetectivePointsAllowed () {
                return (this.$isDetectiveAvailable && this.courseAllowDetective) && (this.$scoring ?
                  this.user.type !== 'student' && this.profile.status === 'active'
                  : this.user.isSuperadmin || this.user.isManagerOrSupport);
            },
            selectorSize () {
                const windowWidth = window.innerWidth;
                return windowWidth >= 1200 ? 'xx-large' : 'x-large';
            },
            isUserInActiveGrades () {
                return this.profile && this.profile.grades.some(grade => grade.status === 'active');
            },
            isShowLink () {
                return this.user.isSuperadmin || this.user.isManagerOrSupport;
            },
        },
        methods: {
            async checkRestorePrice() {
                if (!this.isRestoreUserAllowed()) {
                    return;
                }
                const price = await UserApi.getPriceForActivate(this.profile.id);
                this.priceModal.show = true;
                this.priceModal.price = price;
            },
            changeStatus() {
                if (this.profile.status !== 'active' && !this.isRestoreUserAllowed()) {
                    return;
                }
                this.closePriceModal();
                if (this.profile.school.status === 'archived') {
                    this.$toasted.error(this.$i18n.t('list.list_teacherPreview_cantRestoreStudent'));
                } else {
                    this.profile.status = this.profile.status === 'active' ? 'archived' : 'active';
                    UserApi.update(this.profile.id, {status: this.profile.status, school: this.profile.school})
                        .then(result => {
                            this.$toasted.success(this.$i18n.t('list.list_user_statusChanged'));
                        })
                        .catch(err => {
                            this.profile.status = this.profile.status === 'active' ? 'archived' : 'active';
                        })
                }
            },
            closePriceModal() {
                this.priceModal.show = false;
                this.priceModal.price = 0;
            },
        }
    }
</script>

<style lang="scss" scoped>
    .user-preview {
        background-color: $x-color-white;
        border: 1px solid $x-color-gray-5;
        border-radius: $border-radius-8;
        margin: 8px 0;
        padding: 16px;
    }

    .user-preview__column {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 0;
        margin-bottom: 8px;
        @include media($xlg) {
            margin-bottom: 0;
        }
    }

    .user-preview__column:last-child {
        margin-bottom: 0;
    }

    .user-preview__column:first-child {
        margin-bottom: 16px;
    }

    .user-preview__column_hide-name {
        @include media($sm) {
            display: none;
        }
    }

    .user-preview__name {
        margin-bottom: 16px;
        display: flex;
        align-items: center;
    }

    .user-preview__icon {
        color: $hsl-color-green-58;
    }

    .user-preview__icon_blue {
        color: $hsl-color-blue-56;
    }

    .user-preview__items {
        display: flex;
        margin: -4px 0;
    }

    .user-preview__items_columned {
        flex-direction: column;
    }

    .user-preview__items_limited {
        flex-wrap: wrap;
        max-width: 200px;
    }

    .user-preview__item {
        display: flex;
        align-items: center;

        font-size: 13px;
        line-height: 16px;
    }

    .user-preview__item {
        padding: 4px;
    }

    .preview__text {
        margin-left: 8px;
    }

    .preview__text_large {
        margin-left: 16px;
    }

    .user-preview__link {
        display: flex;
        align-items: center;
        color: $hsl-color-blue-56;
        text-decoration: none;
        &:hover {
            color: $hsl-color-blue-56;
            text-decoration: none;
        }
    }

    .user-preview__link_large {
        display: flex;
        align-items: center;
        font-size: 16px;
        line-height: 20px;
        @include media($lg) {
            font-size: 18px;
        }
    }

    .user-preview__avatar {
        border-radius: 50%;
        max-height: none;
        height: 50px;
        width: 50px;
    }

    .user-preview__info {
        margin: -8px 0;
    }

    .info__column {
        padding: 8px 0;
    }

    .dropdown__links {
        padding: 7px 14px;
        text-align: left;
        font-size: 16px;
        line-height: 26px;
    }

    .dropdown__link {
        padding-bottom: 7px;
        a {
            color: $hsl-color-blue-56;
            text-decoration: underline;
            &:hover {
                color: $hsl-color-blue-56;
                text-decoration: none;
            }
        }
    }

    .price-modal-text {
        margin-top: 20px;
    }

    .price-modal-buttons {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
        .cs-button {
          padding: 15px 20px;
          @include media($md) {
            padding: 15px 30px;
          }
        }
    }
</style>
